import { useEffect, useRef, useState } from "react"

// Mui
import {
  AppBar,
  Button,
  ClickAwayListener,
  Container,
  Fade,
  List,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
  Menu,
  MenuItem,
  Paper,
  Popper,
  Stack,
  Toolbar,
  Typography,
  useTheme
} from "@mui/material"

import Link from "next/link"

import { ArrowDown2, CardAdd, CardTick1, LogoutCurve, User } from "iconsax-react"
import { useRouter } from "next/router"
import { toast } from "react-toastify"
import BasicLogo from "src/components/common/BasicLogo"
import auth from "../../../../../lib/auth"
import Authentication from "../../../../../services/authentication"
import MainCard from "../../../../common/main-card"
import Transitions from "../../../../common/transition"
import { CREDIT_LAYER_ENUM } from "../../../../../services/requests/types"
import Pages from "src/constants/pages"

const LandingAppBar = ({ isOtherPages = false }) => {
  const [anchorEl, setAnchorEl] = useState(null)
  const [merchantsEl, setMerchantsEl] = useState(null)
  const anchorRef = useRef(null)
  const router = useRouter()

  const [open, setOpen] = useState(false)
  const [downloaded, setDownloaded] = useState(false)
  const [user, setUser] = useState()

  useEffect(() => {
    auth.ensureSession().finally(() => {
      setUser(auth.user)
      setDownloaded(true)
    })
  }, [router.pathname])

  const handleClick = event => {
    if (anchorEl !== event.currentTarget) {
      setAnchorEl(event.currentTarget)
    }
  }

  const handleMerchantsClick = event => {
    if (anchorEl !== event.currentTarget) {
      setMerchantsEl(event.currentTarget)
    }
  }

  const handleClose = () => {
    setAnchorEl(null)
  }

  const handleMerchantsClose = () => {
    setMerchantsEl(null)
  }

  const handleToggle = () => {
    setOpen(prevOpen => !prevOpen)
  }

  const handleCloseMenu = event => {
    if (anchorRef.current && anchorRef.current.contains(event.target)) {
      return
    }
    setOpen(false)
  }

  const theme = useTheme()

  const handleEmtaLogin = () => {
    Authentication.emtaLogin().then(response => {
      const { status, data } = response
      if (status === 200) {
        if (!data?.hasValue) {
          toast.error(data?.message) // Show Error Message
        } else {
          window.location.replace(response?.data?.value)
          // router.push(`/verifyLogin/${val?.phoneNumber}`)
          // toast.success("پیامک ارسال شد.")
        }
      }
    })
  }

  // Handle Logout
  const handleLogout = () => {
    auth.logout(router)
  }

  const render = () => {
    if (!downloaded) {
      return ""
    }
    if (downloaded) {
      return (
        <>
          {user ? (
            <>
              <Button
                onClick={handleToggle}
                ref={anchorRef}
                disableElevation
                variant='contained'
                sx={{ borderRadius: "8px" }}
                endIcon={<ArrowDown2 size={12} />}
              >
                {user?.firstName ? user?.firstName + " " + user?.lastName ?? "" : user?.mobileNumber}
              </Button>
              <Popper
                sx={{ zIndex: 2000 }}
                placement='bottom-start'
                open={open}
                anchorEl={anchorRef.current}
                role={undefined}
                transition
                popperOptions={{
                  modifiers: [
                    {
                      name: "offset",
                      options: {
                        offset: [0, 0]
                      }
                    }
                  ]
                }}
              >
                {({ TransitionProps }) => (
                  <Transitions type='fade' in={open} {...TransitionProps}>
                    <Paper
                      sx={{
                        borderRadius: "10px",
                        boxShadow: theme.shadows[2],
                        width: 270,
                        minWidth: 250,
                        maxWidth: 220,
                        [theme.breakpoints.down("md")]: {
                          maxWidth: 200
                        }
                      }}
                    >
                      <ClickAwayListener onClickAway={handleCloseMenu}>
                        <Typography>
                          <MainCard sx={{ width: "100%", borderRadius: "8px", px: 0 }}>
                            <List>
                              <ListItem sx={{ p: 0 }}>
                                <ListItemButton onClick={() => router.push(Pages.Profile)}>
                                  <ListItemIcon sx={{ minWidth: "2rem" }}>
                                    <User size={18} variant='Bold' color='#0958d9' />
                                  </ListItemIcon>
                                  <ListItemText>
                                    <Typography variant='subtitle2'>حساب کاربری</Typography>
                                  </ListItemText>
                                </ListItemButton>
                              </ListItem>
                              <ListItem sx={{ p: 0 }}>
                                <ListItemButton onClick={() => router.push(Pages.Facilities)}>
                                  <ListItemIcon sx={{ minWidth: "2rem" }}>
                                    <CardAdd size={18} variant='Bold' color={theme.palette.info.main} />
                                  </ListItemIcon>
                                  <ListItemText>
                                    <Typography variant='subtitle2'>درخواست ها</Typography>
                                  </ListItemText>
                                </ListItemButton>
                              </ListItem>
                              <ListItem sx={{ p: 0 }}>
                                <ListItemButton onClick={() => router.push(Pages.Transactions)}>
                                  <ListItemIcon sx={{ minWidth: "2rem" }}>
                                    <CardTick1 size={18} variant='Bold' color={theme.palette.warning.main} />
                                  </ListItemIcon>
                                  <ListItemText>
                                    <Typography variant='subtitle2'>تراکنش ها</Typography>
                                  </ListItemText>
                                </ListItemButton>
                              </ListItem>
                              {/* <ListItem sx={{ p: 0 }}>
                                <ListItemButton onClick={() => router.push("/main/requests/transfer")}>
                                  <ListItemIcon sx={{ minWidth: "2rem" }}>
                                    <ArrangeHorizontalSquare size={18} variant='Bold' color={"#6a2f96"} />
                                  </ListItemIcon>
                                  <ListItemText>
                                    <Typography variant='subtitle2'>انتقال اعتبار دیجی‌کالا</Typography>
                                  </ListItemText>
                                </ListItemButton>
                              </ListItem> */}
                              <ListItem sx={{ p: 0 }} onClick={handleLogout}>
                                <ListItemButton>
                                  <ListItemIcon sx={{ minWidth: "2rem" }}>
                                    <LogoutCurve size={18} variant='Bulk' color='#ff0000' />
                                  </ListItemIcon>
                                  <ListItemText>
                                    <Typography variant='subtitle2'>خروج از حساب</Typography>
                                  </ListItemText>
                                </ListItemButton>
                              </ListItem>
                            </List>
                          </MainCard>
                        </Typography>
                      </ClickAwayListener>
                    </Paper>
                  </Transitions>
                )}
              </Popper>
            </>
          ) : (
            <Stack direction='row' alignItems='center' spacing={1.5}>
              <Button
                variant='contained'
                sx={{
                  borderRadius: "20px",
                  background: "#fff",
                  color: "red",
                  "&:hover": {
                    background: "#dfdfdf"
                  }
                }}
                component={Link}
                href='/login'
              >
                ورود
              </Button>
              <Button
                disableElevation
                sx={{ borderRadius: "20px" }}
                variant='contained'
                component={Link}
                href='/register'
              >
                ثبت نام
              </Button>
            </Stack>
          )}
        </>
      )
    }
  }

  return (
    <Container>
      <header>
        <AppBar
          sx={{
            position: "sticky",
            borderRadius: "0 0 25px 25px",
            color: isOtherPages ? theme.palette.text.primary : "#fff",
            background: "transparent"
          }}
          elevation={0}
        >
          <Toolbar sx={{ py: 3, justifyContent: "space-between", alignItems: "center" }}>
            {/* Logo */}
            <Link href='/'>
              <BasicLogo height={90} />
            </Link>

            {/*  Navigation  */}
            <Stack direction='row' alignItems='center' spacing={4} sx={{ display: { xs: "none", md: "flex" } }}>
              {/* <Typography
                fontSize={"16px"}
                variant='subtitle2'
                fontWeight='bolder'
                component={Link}
                href={
                  auth?.isLoggedIn
                    ? `/main?creditLayerId=${CREDIT_LAYER_ENUM.AIR_CONDITIONER}`
                    : `/login?backUrl=/main?creditLayerId=${CREDIT_LAYER_ENUM.AIR_CONDITIONER}`
                }
              >
                تسهیلات کولر آبی
              </Typography> */}
              <Typography
                fontSize={"16px"}
                variant='subtitle2'
                fontWeight='bolder'
                component={Link}
                href={Pages.JetClubPlans}
                target='_blank'
              >
                جت کلاب
              </Typography>
              <div>
                <Typography
                  aria-owns={anchorEl ? "simple-menu" : undefined}
                  aria-haspopup='true'
                  onClick={handleClick}
                  onMouseOver={handleClick}
                  variant='subtitle2'
                  fontWeight='bold'
                  fontSize={"16px"}
                  sx={{ cursor: "pointer" }}
                >
                  سرویس های خاص
                </Typography>
                <Menu
                  PaperProps={{
                    elevation: 0,
                    sx: {
                      overflow: "visible",
                      filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                      mt: 1.5,
                      "& .MuiAvatar-root": {
                        width: 32,
                        height: 32,
                        ml: -0.5,
                        mr: 1
                      },
                      "&:before": {
                        content: '""',
                        display: "block",
                        position: "absolute",
                        top: 0,
                        left: 14,
                        width: 10,
                        height: 10,
                        bgcolor: "background.paper",
                        transform: "translateY(-50%) rotate(45deg)",
                        zIndex: 0
                      }
                    }
                  }}
                  transformOrigin={{ horizontal: "right", vertical: "top" }}
                  anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                  id='simple-menu'
                  anchorEl={anchorEl}
                  open={Boolean(anchorEl)}
                  onClose={handleClose}
                  TransitionComponent={Fade}
                  MenuListProps={{ onMouseLeave: handleClose }}
                >
                  <MenuItem
                    onClick={() => {
                      const LS_KEY = "vehicleData"
                      localStorage.setItem(LS_KEY, "")
                      router.push(Pages.InquiryCar)
                      handleClose()
                    }}
                  >
                    <Typography variant='caption'>استعلام خلافی های وسیله نقلیه</Typography>
                  </MenuItem>
                  {/* <MenuItem
                    onClick={() => {
                      handleClose()
                    }}
                  >
                    <Typography variant='caption'>استعلام تجمیع تخلفات کلی وسیله نقلیه</Typography>
                  </MenuItem> */}
                  {/* <MenuItem onClick={handleClose}>
                    <Typography variant='caption'>استعلام عکس تخلف خودرو</Typography>
                  </MenuItem>
                  <MenuItem onClick={handleClose}>
                    <Typography variant='caption'>استعلام پلاک های شخص</Typography>
                  </MenuItem>
                  <MenuItem onClick={handleClose}>
                    <Typography variant='caption'>استعلام وضعیت گواهینامه</Typography>
                  </MenuItem>
                  <MenuItem onClick={handleClose}>
                    <Typography variant='caption'>استعلام وضعیت پاسپورت(گذرنامه)</Typography>
                  </MenuItem>
                  <MenuItem onClick={handleClose}>
                    <Typography variant='caption'>استعلام ممنوع الخروجی</Typography>
                  </MenuItem>
                  <MenuItem onClick={handleClose}>
                    <Typography variant='caption'>استعلام کارت و سند خودرو</Typography>
                  </MenuItem>
                  <MenuItem onClick={handleClose}>
                    <Typography variant='caption'>استعلام نمره منفی گواهی نامه</Typography>
                  </MenuItem> */}
                </Menu>
              </div>
              <Typography
                aria-owns={anchorEl ? "simple-menu" : undefined}
                aria-haspopup='true'
                onClick={handleMerchantsClick}
                onMouseOver={handleMerchantsClick}
                variant='subtitle2'
                fontWeight='bold'
                fontSize={"16px"}
                sx={{ cursor: "pointer" }}
              >
                پذیرنده ها
              </Typography>
              <Menu
                PaperProps={{
                  elevation: 0,
                  sx: {
                    overflow: "visible",
                    filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
                    mt: 1.5,
                    "& .MuiAvatar-root": {
                      width: 32,
                      height: 32,
                      ml: -0.5,
                      mr: 1
                    },
                    "&:before": {
                      content: '""',
                      display: "block",
                      position: "absolute",
                      top: 0,
                      left: 14,
                      width: 10,
                      height: 10,
                      bgcolor: "background.paper",
                      transform: "translateY(-50%) rotate(45deg)",
                      zIndex: 0
                    }
                  }
                }}
                transformOrigin={{ horizontal: "right", vertical: "top" }}
                anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                id='simple-menu'
                anchorEl={merchantsEl}
                open={Boolean(merchantsEl)}
                onClose={handleMerchantsClose}
                TransitionComponent={Fade}
                MenuListProps={{ onMouseLeave: handleMerchantsClose }}
              >
                <MenuItem component={Link} href={"/merchant"} onClick={handleClose} asPath>
                  <Typography variant='caption'>شبکه پذیرندگان</Typography>
                </MenuItem>
                <MenuItem component={Link} href={"/merchant/request"} onClick={handleClose}>
                  <Typography variant='caption'>درخواست پذیرندگی</Typography>
                </MenuItem>
              </Menu>
              <Typography
                fontSize={"16px"}
                variant='subtitle2'
                fontWeight='bold'
                component={Link}
                href={user ? Pages.LoanPayment : "/payInstallment/0"}
                target=''
              >
                پرداخت اقساط
              </Typography>
              <Typography></Typography>
              {/* <Button
                onClick={handleEmtaLogin}
                variant='contained'
                size='medium'
                sx={{
                  background: "#fff",
                  color: "red",
                  "&:hover": {
                    background: "#dfdfdf"
                  }
                }}
              >
                <Typography sx={{ cursor: "pointer" }} variant='subtitle2' fontWeight='bold' fontSize={"13px"}>
                  ورود پذیرنده
                </Typography>
              </Button> */}
            </Stack>

            {/* Auth */}
            {render()}
          </Toolbar>
        </AppBar>
      </header>
    </Container>
  )
}

export default LandingAppBar
